<template>
  <div class='faq-question-component'>
    <div class='faq-details'>
      <div class='faq-detail' v-for='(question, index) in questions' :key='index' @click='question.open ? closeSection(question) : openSection(question)'>
        <div class='faq-question' :class='{active: question.open}'>
          <div class='faq-banner-container'></div>
          <div class='faq-text'>{{ question.content }}</div>
          <div class="action-container">
             <div class='faq-button' v-if='!question.open'></div>
            <div v-else :class='{isActive: question.open}'></div>
          </div>
        </div>
        <div :ref="`wrapper-${question.id}`" class="wrapper-container" :class="{
          //isOpen: question.response && question.open
        }">
          <div :ref="`question-${question.id}`" class='faq-responses'>
            <div class='faq-response' v-for='(response, index) in question.response' :key='index'>
              <div class='faq-response-text'>{{ response.content  }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: 'FaqQuestionComponent',

  props: ['questions'],

  data () {
    return {
      height: 0
    }
  },

  methods: {
    openSection (question) {
      this.resetAll(question)

      question.open = true

      const wrapper = this.$refs[`wrapper-${question.id}`]

      const el = this.$refs[`question-${question.id}`]
      const { height } = el[0].getBoundingClientRect()

      const tl = gsap.timeline()

      tl
        .to(wrapper[0], {
          duration: 0.5,
          height,
          ease: 'sine.inOut'
        })
        .set(wrapper[0], { height: 'unset' })
    },

    closeSection (question) {
      if (!question.open) return

      const wrapper = this.$refs[`wrapper-${question.id}`]

      const el = this.$refs[`question-${question.id}`]
      const { height } = el[0].getBoundingClientRect()

      gsap.set(wrapper[0], { height: height })

      gsap.to(wrapper[0], {
        duration: 0.5,
        ease: 'sine.inOut',
        height: 0
      })

      question.open = false
    },

    resetAll (question) {
      this.questions.forEach((q) => {
        if (question === q) return
        this.closeSection(q)
      })
    }
  }
}
</script>

<style lang='scss' scoped>

.open-enter-active, .open-leave-active {
  transition: height 2s ease;
  height: 0;
}
.open-enter, .open-leave-to {
  height: 0;
}

.action-container {
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 42px;
  width: 42px;

  margin-right: 18px;

  user-select: none;
  cursor: pointer;
}

.faq-question-component {
  margin-bottom: 10px;

  .faq-details {
    width: 100%;

    .faq-detail {
      background-color: #FFFFFF;
      border-radius: 2px;
      box-shadow: 0 2px 6px 0 rgba(176,175,175,0.5);
      margin-bottom: 24px;

      overflow: hidden;

      cursor: pointer;

      .faq-question {
        position: relative;

        align-items: center;
        display: grid;
        grid-template-columns: 1fr 42px 18px;
        grid-template-rows: 100%;
        padding-top: 18px;
        padding-bottom: 18px;

        transition: all 0.5s ease 0.1s;

        &.active {
          align-items: center;
          color: #FFFFFF;
          transition: all 0.5s ease 0.25s;
        }

        .faq-banner-container {
          position: absolute;

          background-color: #B98A30;
          border-radius: 2px 0 0 2px;

          height: 100%;

          width: 2%;

          transition: all .5s cubic-bezier(0.790, 0, 0.175, 0.675);
        }

        &.active .faq-banner-container {
          width: 100%;
        }

        .faq-text {
          z-index: 1;

          font-size: 14px;

          font-weight: 300;
          padding-left: 26px;
        }

        .faq-button {
          color: #B98A30;
          cursor: pointer;
          font-size: 2.5rem;
          font-weight: 500;
          justify-self: center;

          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-image: url('../../assets/plus.svg')
        }

        .isActive {
          color: #FFFFFF;
          font-size: 2.5rem;
          font-weight: 500;
          grid-column: 3;
          justify-self: center;

          width: 18px;
          height: 18px;
          background-repeat: no-repeat;
          background-image: url('../../assets/moins.svg')
        }
      }

      .wrapper-container {
        height: 0;

        background: transparent;
        overflow: hidden;
      }

      .faq-responses{
        background-color: #FFFFFF;
        padding: 35px;
        letter-spacing: -0.05px;
        line-height: 25px;
        text-align: left;

        .faq-response {
          grid-column: 2;
          padding-bottom: 22px;

          font-size: 14px;
          font-weight: 300;
          line-height: 22px;

          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
